import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getEvents} from "../services/EventService";
import {useLogout} from "./useLogout";
import {formatDate} from "../util/DateUtil";

export function useEvents({page, size, fromDate, toDate, salesRegionId, salesTerritoryId, searchString}, enabled = true) {
    const [events, setEvents] = useState([]);
    const [totalCount, setTotalCount] = useState(0);

    const logout = useLogout();

    if (!page) {
        page = 0;
    }
    if (!size) {
        size = 20;
    }
    if (fromDate) {
        fromDate = formatDate(fromDate);
    }
    if (toDate) {
        toDate = formatDate(toDate);
    }
    const {data, isError, error, refetch} = useQuery({
        queryKey: ["events", page, size, fromDate, toDate, salesRegionId, salesTerritoryId, searchString],
        queryFn: () => getEvents({page, size, fromDate, toDate, salesRegionId, salesTerritoryId, searchString, sortOrder: "DESC"}),
        enabled: enabled,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    useEffect(() => {
        if (data) {
            setEvents(data.events);
            setTotalCount(data.totalCount);
        }
    }, [data]);

    return [events, totalCount, refetch];
}
